// extracted by mini-css-extract-plugin
module.exports = {"points-input":"_2ydnzdd3BP642c-DW0P-"};